// extracted by extract-css-chunks-webpack-plugin
module.exports = {"description":"error-message__description___2Dc0u","nowrap":"error-message__nowrap___1Cg7k"};
    if(module.hot) {
      // 1701818165760
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  